export default __webpack_public_path__ + "static/media/plus-icon.aef60610.svg";